import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent as googleLogEvent, setUserId, setUserProperties } from 'firebase/analytics';
import config from 'config';

const firebaseConfig = config.google.firebaseConfig;
let analytics = null;
if (firebaseConfig != null) {
  const app = initializeApp(firebaseConfig);
  analytics = getAnalytics(app);
}

export function logEvent(eventName, params) {
  if (!analytics) { return; }

  googleLogEvent(analytics, eventName, params);
}

export function setUser(userId, orgId) {
  if (!analytics) { return; }

  if (!userId) {
    setUserId(analytics, null);
    setUserProperties(analytics, { org_id: null });
  } else {
    setUserId(analytics, userId + '');
    setUserProperties(analytics, { org_id: orgId + '' });
  }
}